import React, { forwardRef, useEffect } from 'react';
import InputMask from 'react-input-mask';

const CNPJMaskInput = forwardRef(
  ({ value, onChange, className = '', ...rest }, ref) => {
    useEffect(() => {
      if (value !== undefined && !onChange) {
        console.warn('⚠️ CNPJMaskInput recebeu "value" sem "onChange"');
      }
    }, [value, onChange]);
    return (
      <InputMask
        mask="99.999.999/9999-99"
        value={value}
        onChange={onChange}
        {...rest}
      >
        {inputProps => (
          <input
            {...inputProps}
            ref={ref}
            className={`form-control ${className}`}
          />
        )}
      </InputMask>
    );
  }
);

export default CNPJMaskInput;
